import React from 'react'
import CommonPasswordChange from '../../../common/pages/secure/PasswordChange'
import PageHeader from '../../components/PageHeader'

class PasswordChange extends CommonPasswordChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
  renderPageNavi () {
    return (
      <PageHeader title='パスワードの変更' sub='こちらでご自身のパスワードを変更できます。' history={this.props.history}>
        <ul className='nav nav-pills kw-page-actions'>
          <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
        </ul>
      </PageHeader>
    )
  }
}

export default PasswordChange



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/PasswordChange.js